import React from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import { Form, Icon, Row, Col } from 'antd';
import BasePage from 'components/BasePage';
import styledComp, { FlexColContainer, FlexRowContainer } from 'components/StyledComp';
import CustomButton from 'components/CustomButton';
import FormSelect from 'components-desktop/FormSelect';
import FormSelect2 from 'components-desktop/FormSelect2';
import Panel from 'components-desktop/Panel';
import helpers from 'misc/helpers';
import TableSickLeaves from './components/TableSickLeaves';

const propTypes = {
  form: PropTypes.object.isRequired,
};

@autobind
class SearchCaregiverSickLeavesPage extends BasePage {
  constructor(props) {
    super(props);

    this.state = {
      caregiverNames: [],
      coordinators: [],
      teams: [],

      tableKey: null,
      sickLeaveReport: null,
      isSearchButtonEnable: true,
    };
  }

  componentDidMount() {
    this.getSearchCriteria();
  }

  getTitle() {
    return 'Caregiver Sick Leaves';
  }

  async getSearchCriteria() {
    const promise1 = this.callServiceForObjects('/caregiver/get_id_names');
    const promise2 = this.callServiceForObjects('/coordinator/get_id_names');
    const promise3 = this.callServiceForObjects('/team/get_id_names');

    const results = await Promise.all([promise1, promise2, promise3]);

    this.setState({
      caregiverNames: results[0],
      coordinators: results[1],
      teams: results[2],
    });
  }

  async searchSickLeaves(values) {
    try {
      this.setState({
        isSearchButtonEnable: false,
      });

      const params = {
        caregiverId: helpers.extraFormSelectValue(values, 'caregiverId'),
        coordinatorId: helpers.extraFormSelectValue(values, 'coordinatorId'),
        teamId: helpers.extraFormSelectValue(values, 'teamId'),
        year: helpers.extraFormSelectValue(values, 'year'),
      };

      const sickLeaveReport =
        await this.callServiceForRemoteObject('/sick_leave/generate_report', params);

      this.setState({
        tableKey: `${Date.now()}_${Math.random()}`,
        sickLeaveReport,
      });
    } finally {
      this.setState({
        isSearchButtonEnable: true,
      });
    }
  }

  handleSubmit(e) {
    e.preventDefault();

    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.searchSickLeaves(values);
      }
    });
  }

  renderContent() {
    const { form } = this.props;
    const {
      caregiverNames,
      coordinators,
      teams,
      tableKey,
      sickLeaveReport,
      isSearchButtonEnable,
    } = this.state;

    return (
      <FlexColContainer
        width="match_parent"
        height="wrap_content"
        alignItems="center"
      >
        <Panel
          width="match_parent"
          height="wrap_content"
          margin="0 0 24px 0"
          color="green_haze"
          title="Generate Caregiver Sick Leave Report by Criteria"
          icon="user-add"
        >
          <styledComp.AntdForm
            width="match_parent"
            height="wrap_content"
            onSubmit={this.handleSubmit}
          >
            {/* Content */}
            <FlexColContainer
              width="match_parent"
              height="wrap_content"
              padding="20px 20px"
            >
              <Row type="flex" gutter={24}>
                <Col span={6}>
                  <FormSelect2
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="caregiverId"
                    label="Caregiver Name"
                    placeholder="Select..."
                    options={caregiverNames}
                    showIdAfterName
                  />
                </Col>

                <Col span={6}>
                  <FormSelect
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="coordinatorId"
                    label="Coordinator"
                    placeholder="Select..."
                    options={coordinators}
                  />
                </Col>

                <Col span={6}>
                  <FormSelect
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="teamId"
                    label="Team"
                    placeholder="Select..."
                    options={teams}
                  />
                </Col>

                <Col span={6}>
                  <FormSelect
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="year"
                    label="Year"
                    placeholder="Select..."
                    allowClear={false}
                    initialValue={new Date().getFullYear().toString()}
                    options={['2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023',
                      '2024', '2025', '2026', '2027', '2028', '2029']}
                    isRequired
                  />
                </Col>
              </Row>
            </FlexColContainer>

            {/* Footer */}
            <FlexRowContainer
              width="match_parent"
              height="wrap_content"
              padding="20px 20px"
              justifyContent="center"
              backgroundColor="containerGrayBackground"
            >
              <CustomButton
                width="wrap_content"
                height="32px"
                backgroundColor="green_haze"
                fontSize="14px"
                type="primary"
                loading={!isSearchButtonEnable}
                htmlType="submit"
              >
                GENERATE
                <Icon type="right-circle-o" />
              </CustomButton>
            </FlexRowContainer>
          </styledComp.AntdForm>
        </Panel>

        {sickLeaveReport &&
          <TableSickLeaves
            key={tableKey}
            width="match_parent"
            height="wrap_content"
            margin="0 0 24px 0"
            title="Caregiver Sick Leaves"
            sickLeaveReport={sickLeaveReport}
            coordinators={coordinators}
            teams={teams}
          />
        }
      </FlexColContainer>
    );
  }
}

// https://facebook.github.io/react/docs/typechecking-with-proptypes.html
SearchCaregiverSickLeavesPage.propTypes = propTypes;

export default Form.create()(SearchCaregiverSickLeavesPage);
